module.exports = __webpack_public_path__ + "static/media/www.tulikuuma.fi-restaurant-jolene-tampere.f0099804.png";